import React from "react";

import loginBg from "../assets/ac-imagen-oscura-gestion-administrativa.png";
import Header from "../header/header";

// Components

const PublicLayout = (props) => {
    const {children} = props;

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            height: "100vh"
        }}>
            <Header/>
            <div style={{
                flex: 1,
                display: "flex",
                flexDirection: "column"
            }}>
                <div style={{
                    display: "flex",
                    backgroundImage: `url(${loginBg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "bottom"
                }}
                >
                    <div style={{
                        display: "flex",
                        width: 500,
                        backgroundColor: "#f1f1f1",
                        padding: 50,
                        margin: "auto auto auto 0",
                        height: "calc(100vh - 100px)",
                        overflow: "auto"
                    }}>
                        {children}
                    </div>
                </div>
            </div>
        </div>

    );
};

export default PublicLayout;